module.exports = __webpack_public_path__ + "static/media/mstile-70x70.6217067c.png";